import axios from 'axios';

const instance = axios.create({

 baseURL: process.env.VUE_APP_BASE_URL ||  'https://phntm-chase-backend-548acfa02253.herokuapp.com/'
//baseURL: 'http://localhost:5000/'
});

export default instance;
